import { createFileRoute } from "@tanstack/react-router";
import { StaticInfoPage } from "@/components/static-info-page";
import { CONTACT_CHANNEL } from "@/lib/business-info";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Chính Sách Bảo Mật - Bảo Vệ Dữ Liệu Cá Nhân" },
      {
        name: "description",
        content:
          "Chính sách bảo mật của Bói Đê: cách chúng tôi thu thập, sử dụng và bảo vệ dữ liệu cá nhân người dùng. Tìm hiểu ngay!",
      },
      { property: "og:title", content: "Chính Sách Bảo Mật - Bảo Vệ Dữ Liệu Cá Nhân" },
      {
        property: "og:description",
        content:
          "Tìm hiểu cách Bói Đê thu thập, sử dụng và bảo vệ thông tin của bạn khi sử dụng nền tảng.",
      },
      { property: "og:url", content: "https://boide.online/privacy" },
    ],
    links: [{ rel: "canonical", href: "https://boide.online/privacy" }],
  }),
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <StaticInfoPage
      kicker="PRIVACY POLICY"
      title="Chính sách bảo mật"
      description="Chính sách này mô tả cách Bói Đê thu thập, sử dụng và bảo vệ thông tin của người dùng khi sử dụng nền tảng."
      sections={[
        {
          title: "1. Thông tin được thu thập",
          paragraphs: [
            "Chúng tôi có thể thu thập thông tin tài khoản, thông tin liên hệ, lịch sử tham vấn, giao dịch và dữ liệu kỹ thuật cần thiết để vận hành dịch vụ.",
            "Các nội dung bạn nhập trong quá trình gieo quẻ, lập lá số hoặc chat với AI được dùng để tạo phản hồi và cải thiện trải nghiệm sản phẩm.",
          ],
        },
        {
          title: "2. Mục đích sử dụng",
          paragraphs: [
            "Dữ liệu được sử dụng để xác thực tài khoản, cung cấp dịch vụ, xử lý thanh toán, hỗ trợ khách hàng và đảm bảo an toàn hệ thống.",
            "Chúng tôi không bán thông tin cá nhân của người dùng cho bên thứ ba.",
          ],
        },
        {
          title: "3. Bảo mật dữ liệu",
          paragraphs: [
            "Bói Đê áp dụng các biện pháp kỹ thuật và tổ chức phù hợp để hạn chế truy cập trái phép, mất mát hoặc lạm dụng dữ liệu.",
            "Người dùng nên tự bảo mật thiết bị, mật khẩu và không chia sẻ token đăng nhập cho người khác.",
          ],
        },
        {
          title: "4. Liên hệ về quyền riêng tư",
          paragraphs: [
            `Nếu bạn cần cập nhật, kiểm tra hoặc yêu cầu hỗ trợ liên quan đến dữ liệu cá nhân, vui lòng liên hệ qua ${CONTACT_CHANNEL}.`,
          ],
        },
      ]}
    />
  );
}
